import React from 'react';
import cx from 'classnames';
import styles from './StarRating.module.scss';
import { Typography } from '../../foundations/typography';
import { Stars } from './Stars';
/**
 * @tdr
 * @tdr-deprecated-props: hasSchema
 * @tdr-deprecated-date: 2022-05-20
 */
export var StarRating = function (_a) {
    var _b;
    var rating = _a.rating, children = _a.children, className = _a.className, hasSchema = _a.hasSchema, _c = _a.noReviews, noReviews = _c === void 0 ? false : _c, _d = _a.starSize, starSize = _d === void 0 ? 'xsmall' : _d, formAriaLabel = _a.formAriaLabel, onHighlight = _a.onHighlight, _e = _a.submitHandler, submitHandler = _e === void 0 ? function () { } : _e;
    var classNames = cx(styles.rating, className);
    if (noReviews) {
        return React.createElement(Typography, { element: "span" }, "No review yet");
    }
    return (React.createElement("div", { className: classNames },
        React.createElement(Stars, { hasSchema: hasSchema, rating: rating, starSize: starSize, onHighlight: onHighlight, submitHandler: submitHandler, className: cx((_b = {}, _b[styles.hasText] = !!children, _b)), formAriaLabel: formAriaLabel }),
        children));
};
//# sourceMappingURL=StarRating.js.map